import React from 'react';
import PropTypes from 'prop-types';
import FilterString from '../../FilterString';
import { array as arrayFormatter } from '../../../DataGrid/formatters';

const SuggestionRenderer = ({ name, operator, renderSettings, value }) => {
  const getValue = () => {
    if (['in', 'not_in'].includes(operator)) {
      return <>{arrayFormatter(value ?? [])}</>;
    }

    const [firstSuggestion] = value ?? [];
    return firstSuggestion;
  };

  return (
    <FilterString
      name={name}
      operator={operator}
      value={getValue()}
      renderSettings={renderSettings}
    />
  );
};

SuggestionRenderer.propTypes = {
  name: PropTypes.string,
  operator: PropTypes.string,
  renderSettings: PropTypes.object,
  value: PropTypes.array,
};

SuggestionRenderer.defaultProps = {
  name: '',
  operator: '',
  renderSettings: {},
  value: [],
};

export default SuggestionRenderer;
